export default __webpack_public_path__ + "static/media/HP8.fd741afe.jpg";